import React, { useEffect, useState } from "react";
import NewHeader from "../NewHeader/NewHeader";
import { FaArrowLeft } from "react-icons/fa";
import "./dashboard.css";
// import { ioiosarrowforward } from "react-icons/io";
import Card from "./Card/Card";
import profileImage from "./Assets/profileImage.jpg";
import creditCardIcon from "./Assets/credit-card (1).svg";
import group from "./Assets/group.svg";
import help from "./Assets/help.svg";
import location from "./Assets/location.svg";
import wallet from "./Assets/redwallet.svg";
import order from "./Assets/order.svg";
import { Link } from "react-router-dom";
import { ToggleMenu } from "./UserProfile";
import Footer from "../Footer/Footer";
import { useSelector, useDispatch } from "react-redux";
import { getCustomerDashboard } from "../../Redux/Actions";
import Loader from "../Loader/Loader";

function Dashboard() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.customerDashboard);
  const { loading, packages } = userDetails;

  let userImg = packages?.profile?.image;
  let userName = packages?.profile?.fullname;
  const userRedcashValue = packages?.profile?.redcash;

  useEffect(() => {
    const datekey =  JSON.parse(localStorage.getItem("user"));
    dispatch(getCustomerDashboard(datekey && datekey.token));
  }, []);

  return (
    <div>
      <NewHeader />
      <div className="dashboard__container  desktop_menu">
        <div className="dashboard__container-cardContainer">
          <div className="back_btn">
            <a href={process.env.RAZZLE_APP_BASE_URL}>
              <FaArrowLeft /> My Dashboard
            </a>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div className="profile">
              <img src={userImg ? userImg : profileImage} alt="Profile Image" />
              <h1>Hi, {userName}</h1>
            </div>
          )}

          <div className="dashboard__card-column">
            <Card
              icon={creditCardIcon}
              title="Personal Info"
              slug="/userprofile"
              description="Provide personal details and how we can contact you"
            />
            <Card
              icon={order}
              title="My Orders"
              slug="/myOrders"
              description="Check your orders, bookings and reports"
            />
            
            <Card
              icon={location}
              slug="/myaddresses"
              title="My Addresses"
              description="Your addresses details help us with free sample pickup, delivery"
            />
            <Card
              icon={wallet}
              slug="/myredcash"
              title="My Redcash"
              description="This cash can be used on your bookings"
              userRedcashValue={userRedcashValue}
            />
            <Card
              icon={help}
              title="Help & Support"
              slug="/helpandsupport"
              description="Get all the help you need from our 24X7 team"
            />
          </div>
        </div>
      </div>

     
       <div className=" mobile_menu">
        <ToggleMenu />
      </div>
      <Footer />
    </div>
  );
}

export default {
  component: Dashboard,
};
